// components/ActionRequiredTableRow.tsx
import { FC, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TodoDataProps } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { format } from "date-fns";
import { AuthContext } from "src/context/authContext";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface Props {
  data: TodoDataProps;
  refreshListing: () => void;
  index: number
}

const ActionRequiredTableRow: FC<Props> = ({ data, refreshListing, index }) => {
  const { isManufacturer } = useContext(AuthContext);
  const formatDate = (date: string) => (date ? format(new Date(date), "MM/dd/yyyy") : "");
  const toggleIconRef = useRef<HTMLElement | null>(null);
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  return (
    <tr>
      {/* Patient Name */}
      {/* <td className="text-center align-middle">
      {data.patient_name !== "Redacted" ? (
        <Link to={`/global_patients/${data.patient_id}`}>
          {data.patient_name}
        </Link>
      ) : (
        data.patient_name
      )}
    </td> */}

      {/* Patient ID */}
      <td className="text-center align-middle">
        <Link
          to={`/global_patients/${data.patient_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.patient_id}
        </Link>
      </td>

      {/* Case ID */}
      <td className="text-center align-middle">
        <Link
          to={`/cases/detail/${data.bi_case_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.bi_case_id}
        </Link>
      </td>
      <td className="text-center align-middle">
        {data.auto_transfer ? (
          <i className="fa fa-check text-success"></i>
        ) : (
          <i className="fa fa-times text-danger"></i>
        )}
      </td>
      {/* Reverification */}
      <td className="text-center align-middle">
        {data.drug_name === "iovera°" ? data.drug_name : data.drug_name === "zilretta" ? data.drug_name.toUpperCase() : data.drug_name}

      </td>
      {/* <td className="text-center align-middle">
      {data.reverification && (
        <span className={`${data.reverification.toLowerCase() === "new" ? "" : ""}`}>
          {data.reverification}
        </span>
      )}
    </td> */}


      {/* Date Completed */}
      <td className="text-center align-middle">
        {isManufacturer ? formatDate(data.bi_completed) : data.bi_completed}
      </td>

      {/* Insurance/Payer */}
      <td className="text-center align-middle">
        {isManufacturer ? data.payer : data.insurance_type}
      </td>

        <td className="text-center align-middle">
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip className="custom-tooltip">
                            {data && data.practice &&(
                                <>
                                    <p><strong>Practice Name:</strong> {data.practice.name}</p>
                                    <p><strong>Address:</strong> {data.practice.address}</p>
                                    <p><strong>Phone:</strong> {data.practice.phone_number}</p>
                                    <p><strong>Fax:</strong> {data.practice.fax_number}</p>
                                </>
                            )}
                        </Tooltip>
                    }
                >
                      <span
                          className="text-link text-blue link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover">
                        {data.physician}
                      </span>
                </OverlayTrigger>
            </>
        </td>

      {/* Medical Coverage */}
      <td className="align-middle">
        <span className={`badge ${data.medical_coverage_status_color !== 5 ? "text-white" : ""} background-color-${data.medical_coverage_status_color}`}>
          {data.medical_coverage_status}
        </span>
      </td>
      {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
    </td> */}

      {/* Pharmacy Coverage */}
      <td className="align-middle">
        <span className={`badge ${data.pharmacy_coverage_status_color !== 5 ? "text-white" : ""} background-color-${data.pharmacy_coverage_status_color}`}>
          {data.pharmacy_coverage_status}
        </span>
      </td>
      <td className="text-center fw-bold align-middle">
        {/* <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/> */}
        {data.next_steps ? data.next_steps.next_step_verbiage || "" : ""}
      </td>
    </tr>
  );
}


export default ActionRequiredTableRow;
